import { type DomainAccessControlConfig } from '../utils/domain/accessControl'

export const notificationsAccessControl: DomainAccessControlConfig = [
  { restrictedBannersAllowed: true },
]
